<template>
  <div>
    <div class="row">
      <div class="col">
        <h3 class="font-weight-normal" v-html="$t('shop.cart')"></h3>
      </div>
    </div>
    <div class="row">
      <div class="col-4 col-md-6">
        <h4>{{ $t("shop.itemTitle") }}</h4>
      </div>
      <div class="col-3 col-md-2">
        <h4>{{ $t("shop.itemQuantity") }}</h4>
      </div>
      <div class="col-3 col-md-2">
        <h4>{{ $t("shop.itemPrice") }}</h4>
      </div>
    </div>
    <b-alert :show="disabled" variant="warning">{{
      $t("shop.emptyCart")
    }}</b-alert>
    <div class="row" v-for="item of items" :key="item.id">
      <div class="col-4 col-md-6">{{ item.title }}</div>
      <div class="col-3 col-md-2">{{ item.quantity }}</div>
      <div class="col-3 col-md-2">{{ item.quantity * item.price }}</div>
      <div class="col-2">
        <b-icon-x
          variant="danger"
          font-scale="2"
          @click="removeItem(item)"
        ></b-icon-x>
      </div>
    </div>
    <div class="row">
      <div class="col-7 col-md-8 font-weight-bold">Total</div>
      <div class="col-2 font-weight-bold">{{ total }}</div>
    </div>
    <div class="row mt-4">
      <p class="col font-weight-normal" v-html="$t('shop.p1')" />
    </div>
    <div class="row">
      <p class="col font-weight-bold" v-html="$t('shop.p2')" />
    </div>
    <div class="row">
      <p class="col font-weight-normal" v-html="$t('shop.p3')" />
    </div>
    <div class="row">
      <p class="col font-weight-bold" v-html="$t('shop.p4')" />
    </div>
    <div class="row">
      <p class="col font-weight-normal" v-html="$t('shop.p5')" />
    </div>
    <div class="row">
      <p class="col font-weight-normal" v-html="$t('shop.p6')" />
    </div>
    <div class="row mb-2">
      <p class="col font-weight-normal" v-html="$t('shop.p7')" />
    </div>
    <div class="row">
      <div class="col">
        <b-form @submit.stop.prevent="submit">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group :label="$t('shop.name')">
                <b-form-input
                  :disabled="disabled"
                  id="name"
                  v-model="$v.form.name.$model"
                  :state="validateState('name')"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.form.name.required">{{
                  $t("shop.required")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group :label="$t('shop.phone')">
                <b-form-input
                  id="surname"
                  :disabled="disabled"
                  v-model="$v.form.phone.$model"
                  :state="validateState('phone')"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.form.phone.required">{{
                  $t("shop.required")
                }}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.form.phone.numeric">{{
                  $t("shop.invalidPhone")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group :label="$t('shop.deliveryAddress')">
                <b-form-input
                  v-model="$v.form.address.$model"
                  :disabled="disabled"
                  :state="validateState('address')"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.form.address.required">{{
                  $t("shop.required")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group :label="$t('shop.address')">
                <b-form-input
                  v-model="$v.form.invoiceAddress.$model"
                  :disabled="disabled"
                  :state="validateState('invoiceAddress')"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="mb-3 mb-md-0">
              <b-select
                v-model="$v.form.payment.$model"
                :state="validateState('payment')"
                :disabled="disabled"
                :options="[
                  {
                    value: null,
                    text: $t('shop.paymentOptions'),
                    disabled: true,
                  },
                  {
                    value: 1,
                    text: $t('shop.paymentCash'),
                  },
                  {
                    value: 2,
                    text: $t('shop.paymentWire'),
                  },
                ]"
              ></b-select>
            </b-col>
            <b-col md="6">
              <b-select
                v-model="$v.form.delivery.$model"
                :state="validateState('delivery')"
                :disabled="disabled"
                :options="[
                  {
                    value: null,
                    text: $t('shop.deliveryOptions'),
                    disabled: true,
                  },
                  {
                    value: 1,
                    text: $t('shop.deliveryCourier'),
                  },
                  {
                    value: 3,
                    text: $t('shop.deliveryPersonal'),
                  },
                ]"
              ></b-select>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-form-checkbox-group
                v-model="$v.form.agreed.$model"
                :disabled="disabled"
                :options="options"
                :state="validateState('agreed')"
              >
                <b-form-invalid-feedback
                  v-if="!$v.form.agreed.beTrue"
                  :state="validateState('agreed')"
                  >{{ $t("shop.agreementRequired") }}</b-form-invalid-feedback
                >
              </b-form-checkbox-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-checkbox
                v-model="$v.form.mkt.$model"
                :disabled="disabled"
                :state="validateState('mkt')"
                >{{ $t("shop.updatesAgreement") }}</b-checkbox
              >
            </b-col>
          </b-row>
          <!-- <div class="row my-1">
            <div class="col">
              {{ $t("shop.deliveryPersonalDetails") }}
            </div>
          </div> -->
          <!-- <div class="row my-1">
            <div class="col">
              {{ $t("shop.preorderDetails") }}
            </div>
          </div> -->
          <b-row class="mt-3">
            <b-col>
              <b-button
                variant="success"
                block
                size="lg"
                type="submit"
                :disabled="disabled"
                ><b-icon-check-circle-fill></b-icon-check-circle-fill>
                {{ $t("shop.finalizeOrder") }}</b-button
              >
            </b-col>
          </b-row>
          <b-row class="mt-3 d-md-none">
            <b-col>
              <b-button
                variant="outline-secondary"
                block
                size="lg"
                @click="$bvModal.hide('cart-finalize')"
                :disabled="disabled"
                ><b-icon-x></b-icon-x> {{ $t("shop.close") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  name: "CartFinalize",
  computed: {
    ...mapGetters({
      items: "cart/cartProducts",
      disabled: "cart/isEmpty",
      total: "cart/total",
    }),
  },
  data() {
    return {
      form: {
        name: null,
        phone: null,
        address: null,
        invoiceAddress: null,
        payment: null,
        delivery: null,
        agreed: null,
        mkt: null,
      },
      options: [
        {
          html: this.$t("shop.tos"),
          value: "agreed",
        },
      ],
    };
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    removeItem(item) {
      this.$store.dispatch("cart/removeProductFromCart", item);
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.$http
        .post("shop/purchase/", {
          name: this.form.name,
          phone: this.form.phone,
          delivery_address: this.form.address,
          invoice_address: this.form.invoiceAddress,
          payment: this.form.payment,
          delivery: this.form.delivery,
          marketing: this.form.mkt,
          purchaseitem_set: this.items.map((item) => ({
            item: item.id,
            quantity: item.quantity,
          })),
        })
        .then(() => {
          this.$bvModal.hide("cart-finalize");
          this.$nextTick(() => {
            const messageNode = this.$createElement("h5", {
              domProps: {
                innerHTML:
                  "Vă mulțumim pentru comanda efectuată! Vom lua legătura cu dumneavoastră în cel mai scurt timp.",
              },
              class: "font-weight-normal",
            });
            this.$root.$bvModal
              .msgBoxOk([messageNode], {
                okVariant: "success",
                centered: true,
              })
              .then(() => {})
              .catch(() => {});
          });
        });
      this.$store.dispatch("cart/clearCart");
    },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: { required },
      phone: { required, numeric },
      address: { required },
      invoiceAddress: {},
      payment: {},
      delivery: {},
      agreed: {
        beTrue: (value) => {
          return value?.length > 0;
        },
      },
      mkt: {},
    },
  },
};
</script>

<style scoped></style>
